import React from 'react';
import { Award, Users, Wrench, ThumbsUp } from 'lucide-react';
import { Card, CardContent } from './ui/Card';
export function WhyChooseUsSection() {
  const reasons = [{
    icon: Award,
    title: 'Certified Experts',
    description: 'Our team is fully licensed, insured, and certified in radiant heating installation.'
  }, {
    icon: Users,
    title: 'Local Experience',
    description: '10+ years serving Ontario homeowners. We know exactly what Canadian winters demand.'
  }, {
    icon: Wrench,
    title: 'Quality Materials',
    description: 'We use only top-tier heating cables, sensors, and controllers built to last decades.'
  }, {
    icon: ThumbsUp,
    title: 'Satisfaction Guarantee',
    description: 'We stand behind our work with comprehensive warranties on parts and labor.'
  }];
  return <section className="py-16 bg-white md:py-24" data-id="element-1236">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1237">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1238">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-1239">
            The SunFlow Difference
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-1240">
            We don't just install systems; we build relationships. Here's why
            homeowners trust us with their winter safety.
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1241">
          {reasons.map((reason, index) => <Card key={index} className="text-center border shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group bg-white" data-id="element-1242">
              <CardContent className="pt-8 pb-8 px-6" data-id="element-1243">
                <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6 group-hover:bg-primary group-hover:scale-110 transition-all duration-300" data-id="element-1244">
                  <reason.icon className="h-8 w-8 text-primary group-hover:text-white transition-colors duration-300" data-id="element-1245" />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-3 group-hover:text-primary transition-colors" data-id="element-1246">
                  {reason.title}
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed" data-id="element-1247">
                  {reason.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}